import styled from '@emotion/styled';

import { endDirection } from 'app/styles/selectors/markup';

const ButtonHolder = styled.div`
  label: ButtonHolder;

  width: 100%;
  margin-bottom: 1.5rem;
`;

const ButtonContent = styled.span`
  display: flex;
  align-items: center;
`;

const CrownIcon = styled.svg`
  width: 1.375rem;
  margin-${endDirection}: 0.375rem;
`;

const Styled = {
  ButtonHolder,
  ButtonContent,
  CrownIcon,
};

export default Styled;
